module.exports = __webpack_public_path__ + "img/home-mockup.0192cb06.png";